import { Box, Rating, Stack, Typography } from "@mui/material";
import "../../../css/apply.css";

export default function Course({ course }){

    const rating = parseFloat(course.reviews?.average || 0);

    return (

            <div className="apply-course-row">

                <Box>
                    <img
                        src={course.picture?.url}
                        alt={course.title}
                        className="apply-course-row-img"
                    />
                </Box>

                <Stack spacing={1}>

                    <Typography>
                        {course.title}
                    </Typography>

                    <Typography variant="body2" color="text.secondary">
                        {course.teachers}
                    </Typography>

                    {rating > 0 &&
                        <Stack spacing={1} direction="row" alignItems="center">

                            <Rating 
                                value={rating}
                                precision={0.5}
                                readOnly
                            />

                            <Typography variant="body2" color="text.secondary">
                                {rating.toFixed(1)} ({course.reviews?.count || 0})
                            </Typography>

                        </Stack>
                    }

                </Stack>

            </div>
    )
}